import Service from "../../AuthService";
const MaterialExport = {
    getMaterialExport(page) {
        return Service.get("/material-export?page="+page);
    },
    showMaterialExport(id) {
        return Service.get("/material-export/" + id);
    },
    updateMaterialExport(id, data) {
        return Service.put("/material-export/" + id, data);
    },
    createMaterialExport(data) {
        return Service.post("/material-export", data);
    },
    deleteMaterialExport(id) {
        return Service.delete("/material-export/" + id);
    },
    searchMaterialExport(page,code, date) {
        return Service.post(
            "/search-material-export?page="+page+"&code=" + code + "&date=" + date
        );
    }
};
export default MaterialExport;
